export enum OnboardingStatus {
    PENDING_COA_BACKFILL = 'PENDING_COA_BACKFILL',
    PENDING_USER_COA_ONBOARDING = 'PENDING_USER_COA_ONBOARDING',
    FETCHING_COUPA_PO_DETAILS = 'FETCHING_COUPA_PO_DETAILS',
    PENDING_PO_BACKFILL = 'PENDING_PO_BACKFILL',
    PENDING_INVOICE_BACKFILL = 'PENDING_INVOICE_BACKFILL',
    PENDING_COUPA_ONBOARDING = 'PENDING_COUPA_ONBOARDING',
    ONBOARDED = 'ONBOARDED',
}
